/***
 * Created on 2024/11/19
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import {I18nextProvider, useTranslation} from "react-i18next";
import sharedI18n from "common/SharedI18n";
import {getMyQnapCloudUrl} from "common/ServiceCommon";

function DeleteQidSuccess(props) {
    const { t } = useTranslation();

    return (
        <section className="common-page-wrapper">
            <div className="dialog-header">
                <div className="dialog-header__title">{t('@Account Deleted@')}</div>
            </div>
            <div className="dialog-body">
                <div className="dialog-content">
                    <div className="dialog__sub-title color-primary">
                        {t('@Your myQNAPcloud account has been permanently deleted.@')}
                    </div>
                    <div className="dialog__row-divide mt-20 mb-20"></div>
                    <p>
                        {t('@Although your myQNAPcloud account is immediately delete, it may take longer to remove the old backup data by nolonger than 6 months.@')}
                    </p>
                    <p>
                        {t('@Thank you for trying myQNAPcloud service.@')}
                    </p>
                </div>
            </div>
            <div className="dialog-footer">
                <div className="q-btn-group btn-align-right">
                    <button className="q-btn q-btn--primary"  onClick={e => location.href = getMyQnapCloudUrl()}>
                        {t('@Return to myQNAPcloud Homepage@')}
                    </button>
                </div>
            </div>
        </section>
    );
}

const DeleteQidSuccessIndex = () => {
    return (
        <I18nextProvider i18n={sharedI18n}>
            <DeleteQidSuccess/>
        </I18nextProvider>
    )
}

export default DeleteQidSuccessIndex;